import type { CountryIntelligenceRulesAllowances, Maybe } from "@oysterhr/schema"
import {
  CountryIntelligenceOysterScore,
  CountryIntelligenceRulesAllowancesPaidWhen,
} from "@oysterhr/schema"
import type { TFunction } from "react-i18next"

const valueTransformed = (value: string[] = []) => {
  if (value.length === 0) return ""
  const mathTokens = /[*+/\-%=]/g
  const hasMatchTokens = value.join("").match(mathTokens)
  if (hasMatchTokens) {
    if (value.length === 4) {
      const [grossDuration, , number, percentageSymbol] = value
      const humanizedGrossDuration = grossDuration.toLowerCase().replace("_", " ")
      return `${number}${percentageSymbol} of ${humanizedGrossDuration} salary`
    }
    return value.join("")
  }
  return value.join(" ")
}
export const getValueText = (options: {
  value: string[] | undefined
  t: TFunction
  approximate: boolean
}) => {
  const value = valueTransformed(options.value)
  if (value === "") return options.t("allowancesRules.undefinedCost")
  if (options.approximate) return options.t("allowancesRules.approximateCost", { value })
  return options.t("allowancesRules.exactCost", { value })
}
export const filterStatutory = (allowances: CountryIntelligenceRulesAllowances[]) =>
  allowances?.filter(allowance => {
    return allowance.oysterScore === CountryIntelligenceOysterScore.Statutory
  }) || []

export const paidWhenFrequency = (
  t: TFunction,
  paidWhen: Maybe<CountryIntelligenceRulesAllowancesPaidWhen> | undefined,
) => {
  const { Monthly, Yearly, Anytime } = CountryIntelligenceRulesAllowancesPaidWhen
  const withSpacePrefix = (value: string) => ` ${value}`
  if (!paidWhen) return {}
  if ([Monthly, Yearly].includes(paidWhen)) {
    return {
      periodic: withSpacePrefix(t(`enums.periodic.${paidWhen}`)),
    }
  } else if (paidWhen === Anytime || paidWhen == null) {
    return {
      anytime: withSpacePrefix(t("allowancesRules.anytime")),
    }
  } else {
    return {
      date: withSpacePrefix(
        t("allowancesRules.date", {
          date: t(`enums.months.${paidWhen}`, {
            postProcess: "sentence-case",
          }),
        }),
      ),
    }
  }
}
